import { IMFHolings } from '@/components/Stocks/Widgets/types'
import TransposedDataTable from '../DetailPage/TransposedDataTable'

export default function MFHoldings({
  data = [],
  sectionHeading,
  subheading = '',
  minToShow = 5,
}: {
  data: IMFHolings[]
  sectionHeading: string
  subheading?: string
  minToShow?: number
}) {
  if (!(data.length > 0)) {
    return null
  }

  return (
    <div>
      <TransposedDataTable
        details={{
          display_name: sectionHeading,
          display_subtitle: subheading,
          sliceLength: minToShow,
          contents: [
            {
              tables: [
                {
                  table: {
                    columnHeader: [
                      {
                        id: 1,
                        title: 'Funds',
                        trait: 'text',
                      },
                      {
                        id: 2,
                        title: 'Holdings',
                        trait: 'text',
                      },
                      ...(data?.[0]?.num_shares_held
                        ? [
                            {
                              id: 3,
                              title: 'Shares Held',
                              trait: 'text',
                            },
                          ]
                        : []),
                      ...(data?.[0]?.holding_history?.length
                        ? [
                            {
                              id: 4,
                              title: 'Prev. 12M',
                              trait: 'graph',
                            },
                          ]
                        : []),
                    ],
                    rows: data.map(item => ({
                      columns: [
                        {
                          headerId: 1,
                          title: item?.name ?? '',
                          image_url: item?.logo ?? '',
                          image: {
                            className: 'rounded-full',
                            height: 30,
                            width: 30,
                          },
                        },
                        {
                          headerId: 2,
                          title: `${item?.holding_percentage ?? 0}%`,
                        },
                        ...(item?.num_shares_held
                          ? [
                              {
                                headerId: 3,
                                title: `${item?.num_shares_held}`,
                              },
                            ]
                          : []),
                        ...(item?.holding_history?.length
                          ? [
                              {
                                headerId: 4,
                                trait: 'graph',
                                graphPoints: item.holding_history?.map(
                                  item => item.weighting,
                                ),
                                graphFillColor: '#EBF4EC',
                                graphStrokeColor: '#33A34D',
                              },
                            ]
                          : []),
                      ],
                      url: item.relative_path ?? '',
                    })),
                  },
                },
              ],
            },
          ],
        }}
      />
    </div>
  )
}
